import React from 'react';

export const Button = ({ title, className, onClick, hasValue = false }) => {
  return (
    <button
      className={className}
      onClick={onClick}
      {...(hasValue && { value: title })}
    >
      {title}
    </button>
  );
};
